import { TrendingDown, TrendingUp } from "lucide-react";
import { MiniSpark } from "./MiniSpark";

export function KpiCard({ label, value, delta, deltaKind, spark }: {
  label: string; value: string; delta?: string;
  deltaKind?: "up" | "down" | "muted"; spark?: number[];
}) {
  const color = deltaKind === "up" ? "text-green-700" : deltaKind === "down" ? "text-red-600" : "text-muted-foreground";
  const Icon = deltaKind === "up" ? TrendingUp : deltaKind === "down" ? TrendingDown : null;
  return (
    <div className="bg-card rounded-lg border border-border p-4">
      <div className="text-xs text-muted-foreground uppercase tracking-wide">{label}</div>
      <div className="text-xl font-bold mt-1 text-text">{value}</div>
      {spark && <MiniSpark data={spark} />}
      {delta && (
        <div className={`text-xs mt-1 flex items-center gap-1 ${color}`}>
          {Icon && <Icon className="w-3.5 h-3.5" />}{delta}
        </div>
      )}
    </div>
  );
}
